import { useState } from 'react';

export default function PaintingFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How much does it cost to paint a house in El Paso?',
      answer: 'Interior painting in El Paso typically costs $2-$6 per square foot, while exterior painting ranges from $1.50-$4 per square foot. A standard 2,000 sq ft home interior costs $4,000-$12,000, and exterior painting costs $3,000-$8,000. Factors affecting cost include paint quality, surface condition, number of colors, and project complexity.'
    },
    {
      question: 'How long does it take to paint a house?',
      answer: 'Interior painting of an average home takes 3-5 days, while exterior painting takes 5-7 days depending on weather conditions. Smaller rooms can be completed in 1-2 days. Timeline factors include home size, surface preparation needs, number of coats required, and drying time between coats.'
    },
    {
      question: 'What is the best time of year to paint in El Paso?',
      answer: 'Spring (March-May) and fall (September-November) are ideal for exterior painting in El Paso, with moderate temperatures and lower humidity. Interior painting can be done year-round. Avoid exterior painting during extreme summer heat (above 95°F) or when temperatures drop below 50°F, as this affects paint adhesion and drying.'
    },
    {
      question: 'Do I need to move furniture before painting?',
      answer: 'Professional painters typically move furniture away from walls and cover it with protective sheets. However, removing small items, wall decorations, and valuables beforehand helps speed up the process. Discuss furniture moving with your contractor during the estimate to clarify responsibilities and ensure proper protection.'
    },
    {
      question: 'How long should I wait before moving furniture back?',
      answer: 'Wait at least 24 hours before moving furniture back after painting. For high-traffic areas, wait 48-72 hours for paint to fully cure. Latex paint dries to the touch in 1-2 hours but needs 2-4 weeks to fully cure. Avoid hanging pictures or placing items against walls for at least one week.'
    },
    {
      question: 'What paint brands do El Paso contractors recommend?',
      answer: 'Top contractors in El Paso recommend Sherwin-Williams, Benjamin Moore, and Behr for their durability in desert climates. For exterior painting, elastomeric paints from these brands offer superior protection against El Paso\'s temperature fluctuations and UV exposure. Quality paint lasts 7-10 years exterior and 10-15 years interior.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Common questions about painting services in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 text-left flex items-center justify-between gap-4 hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-${
                      openIndex === index ? 'up' : 'down'
                    }-s-line text-white text-xl`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
